<template>
  <IonContent class="ion-no-padding" :scroll-events="true" @ion-scroll="onScroll">
    <IonRefresher slot="fixed" @ion-refresh="handleRefresh">
      <IonRefresherContent />
    </IonRefresher>

    <PageContentWrapperCompact>
      <DocumentIndex @open-modal="showUploadModal = true" />

      <DocumentUploadModal
        :show="showUploadModal"
        @close="showUploadModal = false"
      />
    </PageContentWrapperCompact>

    <FloatingActionButton
      slot="fixed"
      class="fixed right-4 md:hidden"
      rounded
      @click="showUploadModal = true"
    />
  </IonContent>
</template>

<script setup lang="ts">
import { provide, ref } from 'vue';
import FloatingActionButton from '@/application/components/FloatingAction/FloatingActionButton.vue';
import DocumentUploadModal from '@/documents/components/DocumentUploadModal.vue';
import DocumentIndex from '@/documents/components/DocumentsView.vue';
import PageContentWrapperCompact from "@/application/layouts/ContentWrapper/PageContentWrapperCompact.vue";
import {
  IonContent,
  IonRefresher,
  IonRefresherContent,
  type RefresherEventDetail,
  type ScrollCustomEvent
} from '@ionic/vue';
import { useContractStore } from '@/contracts/stores/contractStore.ts';
import { useDocumentStore } from '@/documents/store/documentStore.ts';

const showUploadModal = ref(false);
const isScrolled = ref(false)

async function handleRefresh(event: CustomEvent<RefresherEventDetail>): Promise<void> {
  try {
    await Promise.all([
      useDocumentStore().fetchDocuments(),
      useContractStore().fetchContractsAndDepots(),
    ]);
  } finally {
    event.detail.complete();
  }
}

const onScroll = (event: ScrollCustomEvent) => {
  isScrolled.value = event.detail.scrollTop > 0
}

provide('isScrolled', isScrolled)
</script>
